"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _MerchandiseIdBillingNameKeyMap = _interopRequireDefault(require("self-service-api/constants/MerchandiseIdBillingNameKeyMap"));

var _MerchandiseIdLists = require("self-service-api/constants/MerchandiseIdLists");

var _BillingNameKeys = require("self-service-api/constants/BillingNameKeys");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _PurchaseTypes = require("self-service-api/constants/PurchaseTypes");

var _PricingSelectors = require("pricing-pages-unified-ui/selectors/PricingSelectors");

var _ActiveHubSelectors = require("pricing-pages-unified-ui/selectors/ActiveHubSelectors");

var _PriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/pricing/PriceDisplay"));

var PerAdditionalUnitSubtext = function PerAdditionalUnitSubtext(_ref) {
  var merchId = _ref.merchId,
      currencyCode = _ref.currencyCode,
      costPerUnit = _ref.costPerUnit;
  var billingNameKey = _MerchandiseIdBillingNameKeyMap.default[merchId];

  if (!_MerchandiseIdLists.QUANTITY_MERCHANDISE_IDS.includes(merchId)) {
    return null;
  }

  var langPath = billingNameKey === _BillingNameKeys.ADDITIONAL_CONTACTS ? 'additionalContacts_jsx' : 'additionalUsers_jsx';
  return _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage.calculator.priceBreakdown.perAdditionalUnitSubtext." + langPath,
    options: {
      price: costPerUnit,
      currencyCode: currencyCode
    },
    elements: {
      PriceDisplay: _PriceDisplay.default,
      FormattedNumber: _FormattedNumber.default
    }
  });
};

PerAdditionalUnitSubtext.propTypes = {
  merchId: _propTypes.default.number.isRequired,
  costPerUnit: _propTypes.default.number,
  currencyCode: _propTypes.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var merchId = _ref2.merchId,
      termId = _ref2.termId;
  var activeHub = (0, _ActiveHubSelectors.activeHubSelector)(state);
  var merchPurchaseType = _HubMap.default[activeHub].merchPurchaseType;
  var costPerUnit = null;

  if (merchPurchaseType === _PurchaseTypes.CONTACT_BASED) {
    costPerUnit = (0, _PricingSelectors.getAdditionalContactsMonthlyCostSelector)(state)(merchId, termId);
  } else if (merchPurchaseType === _PurchaseTypes.SEAT_BASED) {
    costPerUnit = (0, _PricingSelectors.getAdditionalSeatMonthlyCostSelector)(state)(merchId, termId);
  }

  return {
    costPerUnit: costPerUnit
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(PerAdditionalUnitSubtext);

exports.default = _default;
module.exports = exports.default;